<script lang="ts">
  export let modalTitle!: string;
  export let modalMessage!: string;
  export let handleCloseEvent!: any;

  const handleClose = (): void => {
    handleCloseEvent();
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-xl font-bold text-gray-700">{modalTitle}</h1>
    </div>
  </div>

  <div class="shadow rounded-lg bg-gray-50 border-1 m-10 p-4">
    <div class="flex flex-col">
      <div class="flex-1">
        <div class="inline-flex justify-items-center items-center min-w-full p-4">
          <div class="justify-self-start w-full">
            {modalMessage}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-10 flex mx-auto justify-center">
    <button class="py-3 tracking-widest form-button" on:click={handleClose}>ログインへ</button>
  </div>
</div>

<style lang="postcss">
  .form-button {
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    background-color: #0fb9f5;
    width: 352px;
    height: 56px;
  }
</style>
